import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { EmpenhoService } from "administrativo-lib";
import { ModalidadeService } from "compra-lib";
import { BaseResourceRptComponent, Coluna, EddyAutoComplete, LicitacaoPipe, Modalidade } from "eddydata-lib";
import { map } from "rxjs/operators";

@Component({
  selector: 'lib-empenho-modalidade-rpt',
  templateUrl: './empenho-modalidade-rpt.component.html'
})
export class EmpenhoModalidadeRptComponent extends BaseResourceRptComponent {


  @Input() visualizar: boolean = false;
  @Output() visualizarChange: EventEmitter<boolean> = new EventEmitter();

  public parametros: { session?: any, filtros?: any } = {};
  public grupos: { id: 'LC' | 'MD', nome: string }[] = [{ id: 'LC', nome: 'Por Licitação' }, { id: 'MD', nome: 'Por Modalidade' }];
  public grupo: { id: 'LC' | 'MD', nome: string };

  protected datepipe: DatePipe;
  public modalidadeAutoComplete: EddyAutoComplete<Modalidade>;

  constructor(
    private empenhoService: EmpenhoService,
    private modalidadeService: ModalidadeService
  ) {
    super();
  }

  protected afterInit(): void {
    this.datepipe = new DatePipe('pt');
    this.formato = 'pdf';
    this.orientacao = 'landscape';
    this.grupo = this.grupos.find((g) => g.id === 'LC');
  }

  protected obterColunasRelatorio(): Coluna[] {
    let retorno: Coluna[] = [];

    retorno.push({ titulo: 'Licitação', coluna: 'licitacao.numero', alignment: 'left', tipo: 'String', agrupar: true, adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'Nº EMPENHO', coluna: 'numero', alignment: 'center', tipo: 'Number', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'DATA', coluna: 'data_empenho', tipo: 'Date', alignment: 'center', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'Nº OF', coluna: 'compra.numero', alignment: 'center', tipo: 'Number', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'FICHA', coluna: 'ficha.numero', alignment: 'center', tipo: 'Number', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'RECURSO', coluna: 'ficha.recurso.codigo', alignment: 'center', tipo: 'Number', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'MODALIDADE', alignment: 'center', coluna: 'modalidade.nome', tipo: 'String', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'RAZÃO SOCIAL', coluna: 'favorecido.nome', alignment: 'left', tipo: 'String', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'SUB-ELEMENTO', coluna: 'subelemento.nome', alignment: 'left', tipo: 'String', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'VALOR', coluna: 'valor_empenho', alignment: 'right', tipo: 'Number', decimais: 2, adicionaisBody: { border: [false, false, false, false] } });
    retorno = retorno.map((r) => {
      r.adicionaisHeader = { margin: 3, fontSize: 8 };
      return r;
    })
    return retorno;
  }

  public obterColunasfiltroPersonalizado(): Coluna[] {
    const retorno: Coluna[] = [];
    retorno.push({ titulo: 'Nº Processo', coluna: 'processo', tipo: 'String', mask: [{ mask: '0000/0000' }, { mask: '00000/0000' }], notUnmask: true, cols: 6 });
    retorno.push({ titulo: 'Nº Licitação', coluna: 'licitacao.numero', tipo: 'String', mask: [{ mask: '00000/0000' }], cols: 6 });
    retorno.push({ titulo: 'Período', coluna: 'data_empenho', tipo: 'Date', cols: 12 });
    retorno.push({
      titulo: 'Modalidade', coluna: 'modalidade.id', tipo: 'AutoComplete', filtro1: { id: -1, nome: 'TODOS'}, semExcluir: true,
      autocomplete: new EddyAutoComplete(null, this.modalidadeService, 'id', ['nome'], { 'cidade.id': this.login.cidade.id, orderBy: 'codigo' }, { text: ['nome'], number: ['codigo'] }, null, -1, null,
        (pagina: number, limite: number, filtros: {}, filtroStr: string) => this.modalidadeService.filtrar(pagina, limite, filtros).pipe(map(page => {
          page.content.unshift({ id: -1, nome: 'TODOS' });
          return page;
        }))),
      padrao: true, cols: 12
    });

    return retorno;
  }

  public validar(): boolean {
    return true;
  }

  protected tituloRelatorio(): string {
    return `LISTAGEM GERAL DE EMPENHOS POR LICITAÇÃO`;
  }
  protected mensagemVazio(): string {
    return `Não foi encontrado empenhos com o filtro informado.`;
  }

  protected larguraColunas(): (string | number)[] {
    return [60, 'auto', 40, 'auto', 'auto', '*', '*', '*', 80];
  }

  protected totalizarColunas(): (string | {})[] {
    return [{ nome: 'valor_empenho', abaixo: true }];
  }

  public imprimir(): void {
    if (!this.validar())
      return null;
    return super.imprimir();
  }

  protected carregarLista(): Promise<any[]> {
    return new Promise<any[]>((resolve) => {

      const order = [];
      if (this.grupo.id === 'MD')
        order.push('modalidade.nome$ASC');
      order.push('licitacao.numero$ASC', 'data_empenho$ASC');

      let parametros = {
        'orgao.id': this.login.orgao.id, ignoreCondObrig: true, relations: 'ficha.despesa,ficha.recurso,subelemento,favorecido,modalidade,compra', orderBy: order.join(',')
      };

      if (this.parametros?.filtros) {
        if (this.parametros.filtros['modalidade.id'] === -1)
          delete this.parametros.filtros['modalidade.id'];
        parametros = Object.assign(parametros, this.parametros.filtros);
      }

      this.empenhoService.filtrar(0, -1, parametros)
        .subscribe((data) => {
          if (!data?.content)
            resolve(null);
          else
            resolve(data.content.map((c) => {
              if (c.licitacao?.numero)
                c.licitacao.numero = new LicitacaoPipe().transform(c.licitacao.numero);
              else
                c.licitacao = { numero: 'SEM LICITACAO' };
              if (c.subelemento?.nome)
                c.subelemento.nome = `${c.subelemento.codigo} - ${c.subelemento.nome}`;
              return c;
            }).sort((a, b) => {
              if (!a.licitacao.id && b.licitacao.id)
                return 1;
              if (a.licitacao.id && !b.licitacao.id)
                return -1;
              return 0;
            }));
        })
    });
  }


  protected layout(): {} {
    return {
      hLineWidth() {
        return 1;
      },
      vLineWidth(i, node) {
        return 1;
      },
      hLineColor(i) {
        return i === 1 || i === 0 ? 'black' : '0aaa';
      },
      paddingLeft(i) {
        return 2;
      },
      paddingRight(i, node) {
        return 2;
      }
    }
  }
  public show() {
    this.visualizar = true;
    this.visualizarChange.emit(this.visualizar);
  }

  public hide() {
    this.visualizar = false;
    this.visualizarChange.emit(this.visualizar);
  }
}